import {ReportColumnNames} from '../interfaces';

import {DataHeader} from '../components/reporting-table/classes/data-header';
import {IDataTable} from '../components/reporting-table/interfaces/data-table.interface';

export const TradesReportTableConfig = (): IDataTable => {
    return {
        rows: [],
        columns: [
            new DataHeader({
                label: 'Opened',
                selector: ReportColumnNames.Date,
            }),
            new DataHeader({
                label: 'Closed',
                selector: ReportColumnNames.Closed,
            }),
            new DataHeader({
                label: 'Held',
                selector: ReportColumnNames.Held,
            }),
            new DataHeader({
                label: 'Symbol',
                selector: ReportColumnNames.Symbol,
            }),
            new DataHeader({
                label: 'Type',
                selector: ReportColumnNames.Type,
            }),
            new DataHeader({
                label: 'Entry',
                selector: ReportColumnNames.Entry,
                shifted: true
            }),
            new DataHeader({
                label: 'Exit',
                selector: ReportColumnNames.Exit,
                shifted: true
            }),
            new DataHeader({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                shifted: true
            }),
            new DataHeader({
                label: 'Gross',
                selector: ReportColumnNames.Gross,
                shifted: true
            }),
            new DataHeader({
                label: 'Comm',
                selector: ReportColumnNames.COMM,
                shifted: true
            }),
            new DataHeader({
                label: 'Ecn Fee',
                selector: ReportColumnNames.ECNFee,
                shifted: true
            }),
            new DataHeader({
                label: 'SEC',
                selector: ReportColumnNames.SEC,
                shifted: true
            }),
            new DataHeader({
                label: 'TAF',
                selector: ReportColumnNames.TAF,
                shifted: true
            }),
            new DataHeader({
                label: 'NSCC',
                selector: ReportColumnNames.NSCC,
                shifted: true
            }),
            new DataHeader({
                label: 'CLR',
                selector: ReportColumnNames.CLR,
                shifted: true
            }),
            new DataHeader({
                label: 'ORF',
                selector: ReportColumnNames.ORF,
                shifted: true
            }),
            new DataHeader({
                label: 'PTFPF',
                selector: ReportColumnNames.PTFPF,
                shifted: true
            }),
            new DataHeader({
                label: 'EFTT',
                selector: ReportColumnNames.EFTT,
                shifted: true
            }),
            new DataHeader({
                label: 'CAT',
                selector: ReportColumnNames.CAT,
                shifted: true
            }),
            new DataHeader({
                label: 'NET',
                selector: ReportColumnNames.Net,
                shifted: true
            })
        ],
        hiddenColumnIds: [],
        disableColumnsOptions: true
    };
};
